import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Card, Flex, Group, Image, NumberFormatter, Paper, Text, rem, useMatches } from '@mantine/core';
export type DepositBalanceProps = {
  tokenName: string | undefined;
};
export const DepositBalance: React.FC<DepositBalanceProps> = ({
  tokenName
}) => {
  const {
    i18n
  } = useLingui();
  const top = useMatches({
    base: rem(10),
    sm: rem(-20),
    lg: rem(-38)
  });
  const right = useMatches({
    base: rem(10),
    sm: rem(10),
    lg: rem(43)
  });
  return <Card radius={5} p={{
    base: 10,
    sm: 20
  }} pos="relative" bg="var(--input-variant-color)" style={{
    overflow: 'visible'
  }}>
      <Image src="/assets/wallet/money.svg" alt="decoration" pos="absolute" right={right} top={top} w={{
      base: 80,
      sm: 136,
      lg: 180
    }} h={{
      base: 80,
      sm: 136,
      lg: 180
    }} />

      <Flex direction={{
      base: 'column',
      sm: 'row'
    }} gap={{
      base: 10,
      lg: 33
    }} align={{
      base: 'start',
      sm: 'center'
    }}>
        <Group gap={10}>
          <Paper p={8} bd="1px solid var(--icon-primary)" radius={5} bg="transparent" w={119}>
            <Text fz={{
            base: 10,
            sm: 12
          }} fw={700} c="var(--text-prime)" tt="uppercase">
              {tokenName}
            </Text>
            <Text className={gunterzBold.className} fz={{
            base: 14,
            sm: 20
          }} lh={rem(20)} mt={4}>
              <NumberFormatter value={100} thousandSeparator="," decimalSeparator="." decimalScale={9} />
            </Text>
          </Paper>
          <Text c="var(--text-purple)">{'='}</Text>
          <Paper p={8} bd="1px solid var(--icon-primary)" radius={5} bg="transparent" w={119}>
            <Text fz={{
            base: 10,
            sm: 12
          }} fw={700} c="var(--text-prime)" tt="uppercase">
              {i18n._('USD')}
            </Text>
            <Text className={gunterzBold.className} fz={{
            base: 14,
            sm: 20
          }} lh={rem(20)} mt={4}>
              <NumberFormatter value={100.75} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale />
            </Text>
          </Paper>
        </Group>
        <Box w={278} style={{
        wordBreak: 'break-word'
      }}>
          <Text fz={13} c="var(--text-dark)" fw={500}>
            {i18n._('The value of USDT may change between now and the time we receive your payment')}
          </Text>
        </Box>
      </Flex>
    </Card>;
};